import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import {
  CollapseComponent,
  DiyCategoryListAccordion,
  FooterDashComponent,
  FooterPublicComponent,
  FormErrorComponent,
  FormFeedbackComponent,
  HeaderDashComponent,
  HeaderPublicComponent,
  HeroComponent,
  PageTitleComponent,
  PageTitleModalComponent,
  PdfjsViewerComponent,
  PdfViewerPageComponent,
  ProgressbarComponent,
  RequiredFieldLabelComponent,
  TabsComponent
} from './index';
import { CadCurrencyPipe } from './cad-currency.pipe';

@NgModule({
  imports: [
    RouterModule,
    NgbModule.forRoot(),
    CommonModule,
    NgbModule,
    AngularFontAwesomeModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    CadCurrencyPipe,
    HeaderPublicComponent,
    HeaderDashComponent,
    HeroComponent,
    TabsComponent,
    PageTitleComponent,
    PageTitleModalComponent,
    ProgressbarComponent,
    CollapseComponent,
    DiyCategoryListAccordion,
    RequiredFieldLabelComponent,
    FormErrorComponent,
    FormFeedbackComponent,
    FooterDashComponent,
    FooterPublicComponent,
    PdfjsViewerComponent,
    PdfViewerPageComponent
  ],
  exports: [
    NgbModule,
    AngularFontAwesomeModule,
    CadCurrencyPipe,
    HeaderPublicComponent,
    HeaderDashComponent,
    HeroComponent,
    TabsComponent,
    PageTitleComponent,
    PageTitleModalComponent,
    ProgressbarComponent,
    CollapseComponent,
    DiyCategoryListAccordion,
    RequiredFieldLabelComponent,
    FormErrorComponent,
    FormFeedbackComponent,
    FooterDashComponent,
    FooterPublicComponent,
    PdfjsViewerComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [CurrencyPipe]
})
export class GlobalModule {}



// WEBPACK FOOTER //
// ./src/app/global/global.module.ts